var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddNextLine = function SvgAddNextLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.77 5.104h10.312M6.77 8.15h10.312m-4.687 3.047h4.687m-4.687 3.047h4.687m-9.843.235 2.812-1.758-2.813-1.758m-1.923-.048H3.698m0 0H2.082m1.616 0v1.616m0-1.616V9.3"
  })));
};
export default SvgAddNextLine;